import React, {useEffect, useState} from 'react';
import { Background, Header } from './style'
import SummaryWallet from './SummaryWallet';
import DetailWallet from "./DetailWallet";
import AmountOperation from './AmountOperation';
import {useDispatch, useSelector} from "react-redux";
import {showNavBar} from "../../_store/_actions/uiActions";
import PartnerInfo from "../PartnerInfo/PartnerInfo";
import HttpClient from "../../_services/httpClient";

const Wallet = () => {
    const dispatch = useDispatch();
    const { partnerId } = useSelector(state => state.repository.partner);
    const [summary, setSummary] = useState({});
    const [detail, setDetail] = useState([]);

    const getData = (url) => {
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    eject(error);
                })
        });
    }

    const handleSummaryWallet = () => {
        if (partnerId > 0) {
            getData(`/Wallet/SummaryWallet/${partnerId}`).then((response) => {
                if (response.status === 200) {
                    setSummary(response.data);
                }
            })
        }
    }

    const handleWalletDetail = () => {
        if (partnerId > 0) {
            getData(`/Wallet/WalletDetail/ByPartner/${partnerId}`).then((response) => {
                if (response.status === 200) {
                    setDetail(response.data);
                }
            })
        }
    }

    useEffect(() => {
        handleSummaryWallet();
        handleWalletDetail();
    }, [partnerId]);


    useEffect(() => {
        dispatch(showNavBar());
    },[])

    return (
        <>
            <Background>
                <Header>
                    <div className="row col-md-12 divcenter">
                        <div className="col-md-3">
                            <div className="title">
                                <h2>My Wallet</h2>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <span>In this section of your <b>SHARED ECONOMY Partner Portal</b> you will find everything related to your <b>ECO's, Air ECO's</b> and <b>Cashable USD.</b>
                                Review your ECO's usage history and keep track of your past and future Air ECO's earnings. If you decide to do so, transfer any amount
                                of your Cashable USD balance to pay off your <b>REEF Hotels Membership.</b></span>
                        </div>
                    </div>

                    <div id="partner-info-wallet" className="">
                        <PartnerInfo SearchBar={false}/>
                    </div>

                    <div className="row col-md-12 divcenter">
                        <div className="col-md-4">
                            <SummaryWallet title="Air ECOs" value={ summary.summaryAirEco }>
                            </SummaryWallet>
                        </div>

                        <div className="col-md-4">
                            <SummaryWallet title="ECO's" value={summary.summaryEco}>
                            </SummaryWallet>
                        </div>

                        <div className="col-md-4">
                            <SummaryWallet title="Cashable USD" value={ summary.summaryCashableUsd }>
                            </SummaryWallet>
                        </div>

                    </div>
                </Header>

                <div className="divcenter">
                    <DetailWallet data={ detail } />
                </div>

                <div className="container-fluid clearfix">
                    <div className="row col-md-12">
                        <div className="col-md-6 pl-md-5">
                            <h4 className="pt-5">Redeem any amount of your Air ECO's balance to be used for Airfare.</h4>
                        </div>
                        <div className="col-md-6">
                            <AmountOperation title="AMOUNT TO REEDEM:" button="REDEEM"></AmountOperation>
                        </div>
                    </div>

                    <div className="row col-md-12">
                        <div className="col-md-6 pl-md-5">
                            <h4 className="pt-5">Convert any amount of your Air ECO's balance to Cashable USD.</h4>
                        </div>
                        <div className="col-md-6">
                            <AmountOperation title="AMOUNT TO TRANSFER:" button="CONVERT"></AmountOperation>
                        </div>
                    </div>
                </div>
            </Background>
        </>
    )
}

export default Wallet;